import { render, staticRenderFns } from "./ReleasePage.vue?vue&type=template&id=7f521352&scoped=true"
import script from "./ReleasePage.vue?vue&type=script&lang=js"
export * from "./ReleasePage.vue?vue&type=script&lang=js"
import style0 from "./ReleasePage.vue?vue&type=style&index=0&id=7f521352&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f521352",
  null
  
)

export default component.exports